import {PopupsStateType} from './types';
import {MinPopupHeight} from '../../../constants';

export const DefaultPopupsState: PopupsStateType = {
    needToShow: false,
    modalPopup: null,
    modalPopupSize: {
        height: MinPopupHeight,
    },
};